export enum CustomersStepTypeEnum {
    AboutYou = 'ABOUT_YOU',
    Insurance = 'INSURANCE',
    Prescriptions = 'PRESCRIPTIONS',
    Review = 'REVIEW',
    ThankYou = 'THANKYOU',
    Done = 'DONE'
}

export enum CustomersStepTypeEnumPaths {
    ABOUT_YOU = 'about-you',
    INSURANCE = 'insurance',
    PRESCRIPTIONS = 'prescriptions',
    REVIEW = 'review',
    THANKYOU = 'thank-you',
    DONE = 'done'
}

export enum InvoicesStateEnum {
    CLOSED = 'CLOSED',
    UNPAID = 'UNPAID',
    DONE = 'DONE',
    OPEN = 'OPEN',
    AUTHORIZED = 'AUTHORIZED',
    BAD_DEBT = 'BAD_DEBT',
    OVER_CHARGED = 'OVER_CHARGED'
}